<template>
  <div id="Admin">

    <p v-if="!ready">{{ $t('message.loading') }}</p>

    <section
      v-else
      style="padding: 10px;font-size: 13px;">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <h4>แนวโน้มการใช้งานของ Application ทั้งหมด</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <GChart
                :data="chartData1"
                :options="{
                  title: 'รูปแบบ',
                  pieHole: 0.5,
                  width: 600,
                  height: 600
                }"
                width="800"
                type="PieChart"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GChart } from 'vue-google-charts'

export default {
  name: 'AdminAnalyticsBusnessType',

  components: {
    GChart,
  },

  data () {
    return {
      ready: false,
    }
  },

  computed: {
    ...mapGetters({
      getAppInfo: 'getAppInfo',
    }),

    chartData1 () {
      let data = [
        ['Type', 'Count'],
      ]

      let responseData = this.$store.getters['analytic/getState']('trendApp')

      for (let item of responseData) {
        let column = this.$t(this.getAppInfo(item.app_id).translate).title
        let count = item.api_request_count
        data.push([column, count])
      }

      return data
    },
  },

  async created () {
    await this.$store.dispatch('analytic/getTrendApp')
    this.ready = true
  },

}
</script>



// WEBPACK FOOTER //
// src/components/admin/analytics/TrendApplication.vue